import React from 'react';
import sortArrowUp from '../../../assets/images/sort-arrow-up.svg';
import sortArrowDown from '../../../assets/images/sort-arrow-down.svg';

const SortableHeader = ({ 
  header, 
  isSortable = false, 
  sortDirection = null, 
  secondarySortDirection = null,
  onSort = null,
  columnIndex 
}) => {
  const handleClick = () => {
    if (isSortable && onSort) {
      onSort(columnIndex);
    }
  };

  const getSortIcon = () => {
    if (!isSortable) return null;
    
    const iconStyle = {
      width: '16px',
      height: '16px',
      padding: 0,
      margin: 0,
      flexShrink: 0,
      minWidth: '16px',
      minHeight: '16px'
    };
    
    // Check if this is the primary sort column
    if (sortDirection === 'asc') {
      return <img src={sortArrowUp} alt="Sort ascending" className="sort-icon" style={iconStyle} />;
    } else if (sortDirection === 'desc') {
      return <img src={sortArrowDown} alt="Sort descending" className="sort-icon" style={iconStyle} />;
    }
    
    // Check if this is the secondary sort column (Date Approved) and show its icon
    if (secondarySortDirection === 'asc') {
      return <img src={sortArrowUp} alt="Sort ascending" className="sort-icon" style={iconStyle} />;
    } else if (secondarySortDirection === 'desc') {
      return <img src={sortArrowDown} alt="Sort descending" className="sort-icon" style={iconStyle} />;
    }
    
    return null;
  };

  return (
    <th 
      scope="col" 
      className={isSortable ? 'sortable-header' : ''}
      onClick={handleClick}
      style={{ 
        cursor: isSortable ? 'pointer' : 'default',
        margin: 0,
        border: 'none'
      }}
    >
      <div 
        className="header-content"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          padding: 0,
          margin: 0,
          gap: '4px'
        }}
      >
        <span style={{ padding: 0, margin: 0 }}>{header}</span>
        {getSortIcon()}
      </div>
    </th>
  );
};

export default SortableHeader; 